import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=4eca1568&scoped=true&"
import script from "./LayoutAuth.vue?vue&type=script&lang=js&"
export * from "./LayoutAuth.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=4eca1568&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eca1568",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})


/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eca1568')) {
      api.createRecord('4eca1568', component.options)
    } else {
      api.reload('4eca1568', component.options)
    }
    module.hot.accept("./LayoutAuth.vue?vue&type=template&id=4eca1568&scoped=true&", function () {
      api.rerender('4eca1568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/LayoutAuth.vue"
export default component.exports